







import Vue from 'vue'

import {Component, Inject, Prop} from 'vue-property-decorator'
import {Observer} from 'mobx-vue'

import { Webhook } from '../../../stores/Webhooks'

import PluginInfo from '../../plugins/PluginInfo.vue'


@Observer
@Component({components: {PluginInfo}})
export default class PluginSelect extends Vue {
    @Prop()
    webhook!: Webhook
}
